import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: '[app-square-box]',
    templateUrl: './square-box.component.html',
    styleUrl: './square-box.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SquareBoxComponent {
  x = input(0);
  y = input(0);
  width = input(200);
  height = input(200);
}
